import { createContext } from "react";

import { CollapsiblePanelContextType } from "./types";

export const CollapsiblePanelContext = createContext<CollapsiblePanelContextType | undefined>(
  undefined
);
